export interface AnalyticsEarliestDate {
  date: string;
}

/**
 * Identifies the DevSite area that owns an analytics event.
 *
 * Kept in shared code so client- and server-originated events use the same
 * Mixpanel event prefix.
 */
export enum FunctionalArea {
  ABOUT = 'About',
  ADMIN_TOOLS = 'Admin Tools',
  API_DISCOVERY_CENTER = 'API Discovery Center',
  APP_BUILDER = 'App Builder',
  APP_CATALOG = 'App Catalog',
  CONSOLE = 'Console',
  COPILOT = 'Copilot',
  DEV_AGENT = 'Dev Agent',
  DOCUMENTATION = 'Documentation',
  DOWNLOADS = 'Downloads',
  GENERAL = 'Dev Site General',
  GRAPH_API_EXPLORER = 'Graph API Explorer',
  GRAPHQL_CHANGELOG = 'GraphQL Changelog',
  HOME_PAGE = 'Home Page',
  GETTING_STARTED = 'Getting Started',
  LEARN = 'Learn',
  CONNECTORS = 'Connectors',
  ORCHESTRATION_ACTIVITY = 'Orchestration Activity',
  ORCHESTRATION_BUILDER = 'Orchestration Builder',
  REST_API_EXPLORER = 'REST API Explorer',
  SOAP_API_EXPLORER = 'SOAP API Explorer',
  STUDIO_BUILDER = 'Studio Builder',
  MCP_EXPLORER = 'MCP Explorer',
}
